<template>
  <div class="tnc">

    <section class="kelas-internasional">
      <div>
        <h3 style="font-weight: 500;">Kelas Internasional Kini Dibuka</h3>
        <p>
          PSPP Penerbangan menghadirkan dua pilihan program unggulan yang dapat disesuaikan dengan minat dan tujuan
          karier
          Anda. Temukan jalur pendidikan terbaik untuk meraih masa depan.
        </p>


        <img src="./../assets//kelas-internasional.png" width="100%" />

      </div>
    </section>

    <div v-if="false">
      <br />
      <h3>PENTING</h3>
      <p>
        Segala bentuk pembayaran hanya melalui No Rekening resmi <br /> Bank BRI 0098-01-002137-30-3 an PSPP
        Penerbangan. <br />
        PSPP tidak bertanggungjawab terhadap pembayaran diluar rekening PSPP diatas.
      </p>
    </div>


    <div class="btn-wrapper">
      <button type="button" class="btn btn-primary" @click="$emit('lanjut')">LANJUT KE PENDAFTARAN</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tab: 'staff',
      tabProgram: 'internasional'
    }
  }
}
</script>

<style lang="scss">
.tab {
  list-style: none;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding: 0;
  border-bottom: 1px solid #ccc;

  &.program {
    grid-template-columns: repeat(2, 1fr);
  }

  li {
    font-size: 14px;
    text-align: center;
    padding: 10px 0;

    &.active {
      color: var(--primary);
      font-weight: 500;
      border-bottom: 2px solid var(--primary);
    }

    &:hover {
      cursor: pointer;
      color: var(--primary);
    }
  }
}

.syarat-pendaftaran {
  max-width: 600px;
  margin: 0 auto 20px;

  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
}

.syarat {
  margin: 0 auto;
  padding-left: 20px;

  li {
    font-size: 14px;
    line-height: 22px;
  }
}

.kelas-internasional {
  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }

  >div {
    padding: 15px 0;
    max-width: 600px;
    margin: 0 auto;
  }

  p {
    font-size: 14px;
    line-height: 20px;
  }
}

.btn-wrapper {
  max-width: 600px;
  margin: 20px auto;

  @media screen and (max-width: 768px) {
    padding: 0 20px;
  }
}
</style>